export default "__VITE_ASSET__RfGrVlQ5__"